<template>
  <div id="searchbox" class="card-body bg-white shadow rounded m-3 mb-5">
    <Transition>
      <div v-if="loading" class="col-12 text-center mb-3">
        <div class="modal fade show mt-5" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content rounded shadow">
              <div class="modal-body">
                <p><b>Caricamento risultati in corso...</b></p>
                <div class="spinner-grow text-primary mb-3" role="status"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <div class="px-3 d-flex flex-wrap align-items-center mb-2">
      <!-- Input di ricerca senza label -->
      <div class="form-group mb-2 me-2" style="flex-grow: 1; max-width: 220px;">
        <input id="text-search" type="text" class="form-control w-100" v-model="searchInput" @change="search"
          @keyup.enter="search" placeholder="Ricerca per contenuti" />
        <Transition>
          <a v-if="searchInput" class="cpointer mt-1 d-inline-block" @click="clearSearch">
            Ripristina filtro contenuto
          </a>
        </Transition>
      </div>

      <!-- Pulsante cerca con icona lente -->
      <button type="button" :disabled="!searchInput && !dateInput && !dlgsInput" @click="search"
        class="btn btn-primary mb-2">
        <i class="bi bi-search"></i>
      </button>
    </div>
  </div>
</template>


<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchInput: "",
      dateInput: "",
      dlgsInput: (new Date()).toISOString().split('T')[0],
      loading: false,
      debounceTimer: null,
    }
  },
  props: {
    treeContainer: { type: Object, required: true }
  },
  mounted() {
    this.search = this.debounced(this.performSearch, 500);
    this.clearSearch();
  },
  methods: {
    debounced(fn, delay) {
      return (...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    currentDateToDlgsValue() {
      return (new Date()).toISOString().split('T')[0]
    },
    async clearSearch() {
      this.loading = true
      this.searchInput = "";
      if (this.treeContainer.contentTree) {
        this.treeContainer.contentTree.setUnfiltered()
        this.treeContainer.updateContentTree();
      }
      this.loading = false
    },
    async clearDate() {
      this.loading = true
      this.dateInput = "";
      if (this.treeContainer.contentTree) {
        this.treeContainer.contentTree.setUnfiltered()
        this.treeContainer.updateContentTree();
      }
      this.loading = false
    },
    async clearDlgs() {
      this.loading = true
      this.dlgsInput = (new Date()).toISOString().split('T')[0];
      if (this.treeContainer.contentTree) {
        this.treeContainer.contentTree.setUnfiltered()
        this.treeContainer.updateContentTree();
      }
      this.loading = false
    },
    // Funzione originale di ricerca che verrà chiamata con debounce
    async performSearch() {
      // Non eseguire la ricerca se la data è inferiore al minimo consentito (01/04/2023)
      if (this.dateInput) {
        // Converti le stringhe in oggetti Date per un confronto corretto
        const inputDate = new Date(this.dateInput);
        const minDate = new Date("2023-04-01");

        if (inputDate < minDate) {
          // Imposta la data al minimo consentito senza eseguire la ricerca
          this.dateInput = "2023-04-01";
          return;
        }
      }
      if (!this.searchInput && !this.dateInput && !this.dlgsInput) { //se non è attivo nessun input di ricerca pulisci i filtri
        this.clearSearch();
        return;
      }
      const response = await fetch(this.$root.config.VUE_APP_API_URL + '/articles?search=' + this.searchInput + '&date=' + this.dateInput + '&dlgs=' + this.dlgsInput)
      if (response.ok) {
        const results = await response.json()
        if (results.status == "success") {
          this.treeContainer.contentTree.filterBySearchResults(results.data)
        }
        console.log('Aggiornamento nodi - 0 , treeKey:', this.treeContainer.contentTree.nodes);
        this.treeContainer.updateContentTree()
        console.log('Aggiornamento nodi - 1 , treeKey:', this.treeContainer.contentTree.nodes);
        console.log('Prima:', this.treeContainer.contentTree.nodes);
        this.treeContainer.contentTree.nodes = [...this.treeContainer.contentTree.nodes]
        console.log('Dopo:', this.treeContainer.contentTree.nodes);
        this.treeContainer.treeKey++;

        this.loading = false
        console.log('Dopo - prima emit:', this.treeContainer.contentTree.nodes);
        this.$emit('tree-updated');
        console.log('Dopo - dopo emit:', this.treeContainer.contentTree.nodes);
        //TODO: gestisci l'errore
      }
    }
  }
}
</script>

<style scoped>
#searchbox {
  position: sticky;
  top: 0.1875rem;
  z-index: 1000;
  max-width: 100%;
  margin-bottom: 1rem !important;
  /* nuovo margin-bottom */
}

.cpointe {
  cursor: pointer;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>